export default __webpack_public_path__ + "static/media/support.0df2d859.svg";